module.exports = __webpack_public_path__ + "img/AlgorithmicFlow-FutureOfFlow.51755019.png";